import { Button, Card, Space, Typography } from 'antd';
import { TeamOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const { Title, Paragraph } = Typography;

// Заглушка дашборда (M2.6). Реальные виджеты (KPI, конверсия привязки,
// просроченные заказы) делаем на M3+. Пока — простой welcome-блок.
export function DashboardPage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '40px 16px' }}>
      <Card>
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          <Title level={3} style={{ margin: 0 }}>
            {t('dashboard.title')}
          </Title>
          <Paragraph type="secondary">{t('dashboard.subtitle')}</Paragraph>
          <Link to="/customers">
            <Button type="primary" icon={<TeamOutlined />} size="large">
              {t('dashboard.cta_customers')}
            </Button>
          </Link>
        </Space>
      </Card>
    </div>
  );
}
